import React, { useState } from "react";
import SecureMode from "assets/img/Securemode.png";
import SchoolDrive from "assets/img/schooldrive.png";
import UjianDigital from "assets/img/soal.png";
import MonitoringSiswa from "assets/img/monitoring.png";
import JurnalPengajaran from "assets/img/jurnal.png";
import EvaluasiPembelajaran from "assets/img/Evaluasi.png";

const tabs = [
  {
    label: "Pembelajaran Terintegrasi",
    title: "Pembelajaran Terintegrasi",
    image: UjianDigital,
    description:
      "Beragam materi pembelajaran, tugas, diskusi, dan kolaborasi tersedia dalam satu platform terpadu dengan sinkronisasi data otomatis. Aktivitas pembelajaran terhubung secara langsung dengan presensi, penilaian, dan laporan perkembangan siswa tanpa input berulang.",
  },
  {
    label: "Penilaian Digital",
    title: "Penilaian Digital",
    image: SecureMode,
    description:
      "Memudahkan pengelolaan, pengolahan, dan analisis penilaian secara digital dengan proses perhitungan otomatis yang akurat. Sistem mendukung rekap nilai real-time, analisis capaian belajar, serta penyajian data yang siap digunakan untuk berbagai kebutuhan pelaporan.",
  },
  {
    label: "Jurnal dan Administrasi",
    title: "Jurnal dan Administrasi",
    image: UjianDigital,
    description:
      "Mendukung pencatatan jurnal mengajar, administrasi pembelajaran, dan dokumentasi madrasah secara digital. Satu kali input dapat menghasilkan berbagai kebutuhan administrasi secara otomatis sehingga mengurangi pekerjaan berulang dan meningkatkan efisiensi operasional.",
  },
  {
    label: "Presensi Guru dan Siswa",
    title: "Presensi Guru dan Siswa",
    image: MonitoringSiswa,
    description:
      "Pencatatan kehadiran guru dan siswa secara real-time, akurat, dan mudah dipantau hingga per jam pelajaran. Data presensi terintegrasi langsung dengan aktivitas pembelajaran, laporan, serta dashboard monitoring sekolah.",
  },
  {
    label: "School Drive",
    title: "School Drive",
    image: SchoolDrive,
    description:
      "Penyimpanan dan berbagi dokumen secara aman dengan manajemen akses yang terstruktur untuk mendukung kolaborasi dan pengelolaan data sekolah. Dokumen tersimpan secara terpusat sehingga memudahkan pencarian, pengarsipan, dan distribusi informasi.",
  },
  {
    label: "Rapor Griya Belajar",
    title: "Rapor Griya Belajar",
    image: UjianDigital,
    description:
      "Penyajian rapor digital dan hasil diagnostik siswa yang informatif, transparan, dan mudah diakses oleh siswa maupun orang tua. Data ditampilkan secara terintegrasi untuk memberikan gambaran perkembangan akademik secara menyeluruh.",
  },
  {
    label: "Evaluasi Pembelajaran",
    title: "Evaluasi Pembelajaran",
    image: EvaluasiPembelajaran,
    description:
      "Mendukung analisis capaian pembelajaran berbasis data untuk perbaikan proses belajar yang berkelanjutan. Sistem membantu mengidentifikasi tren, kekuatan, dan area yang memerlukan perhatian melalui dashboard dan laporan yang diperbarui secara otomatis.",
  },
];

export default function SecPoint() {
  const [activeTab, setActiveTab] = useState("Jurnal dan Administrasi");

  const selectedTab =
    tabs.find((tab) => tab.label === activeTab) ?? tabs[2];

  return (
    <section className="w-full overflow-hidden bg-[radial-gradient(circle_at_15%_50%,#147a39_0%,#0b5c2c_42%,#032312_100%)] px-4 py-10 font-['Inter',sans-serif] text-white sm:px-6 sm:py-12 md:px-8 md:py-16 lg:px-12 lg:py-20">
      <div className="mx-auto w-full max-w-7xl min-w-0">
        {/* Header Section */}
        <div className="flex flex-col gap-4 sm:gap-6 lg:flex-row lg:items-center lg:justify-between lg:gap-8">
          <h2 className="text-xl font-semibold leading-tight sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl">
            Fitur Unggulan DIAJENG LEARNING
          </h2>

          <a
            href="#fitur"
            className="inline-flex w-max shrink-0 items-center gap-2 rounded-lg border border-white/20 bg-white/10 px-4 py-2.5 text-sm font-semibold shadow-sm transition hover:border-white/30 hover:bg-white/20 sm:px-5 sm:py-3 sm:text-base md:gap-3"
          >
            Lihat Fitur Selengkapnya
            <span
              className="text-lg leading-none"
              aria-hidden="true"
            >
              →
            </span>
          </a>
        </div>

        {/* Tabs Navigation */}
        {/* Tabs Navigation */}
<div className="relative mt-6 w-full min-w-0 sm:mt-8">
  <div
    className="
      flex
      w-full
      min-w-0
      gap-2
      overflow-x-auto
      overflow-y-hidden
      scroll-smooth
      pb-3
      sm:gap-3
      [scrollbar-width:none]
      [&::-webkit-scrollbar]:hidden
    "
  >
    {tabs.map((tab) => {
      const isActive = tab.label === activeTab;

      return (
        <button
          key={tab.label}
          type="button"
          onClick={() => setActiveTab(tab.label)}
          className={`
            shrink-0
            whitespace-nowrap
            rounded-full
            border
            px-4
            py-2
            text-xs
            font-semibold
            transition
            sm:px-5
            sm:py-2.5
            sm:text-sm
            md:text-base
            ${
              isActive
                ? "border-white bg-white text-[#063614]"
                : "border-white/25 bg-transparent text-white/60 hover:border-white/50 hover:text-white/80"
            }
          `}
          aria-pressed={isActive}
        >
          {tab.label}
        </button>
      );
    })}
  </div>
</div>

        {/* Content Section */}
        <div className="mt-10 grid min-w-0 items-center gap-8 sm:mt-12 md:mt-14 lg:mt-16 lg:grid-cols-2 lg:gap-12 xl:gap-16">
          {/* Text Content */}
          <div className="min-w-0 flex flex-col justify-center">
            <h3 className="text-2xl font-bold leading-tight sm:text-3xl md:text-4xl lg:text-5xl">
              {selectedTab.title}
            </h3>

            <p className="mt-3 text-justify text-sm leading-relaxed text-white/80 sm:mt-4 sm:text-base md:mt-5 md:text-lg lg:text-xl lg:leading-relaxed">
              {selectedTab.description}
            </p>
          </div>

          {/* Image Section */}
          <div className="flex min-w-0 justify-center lg:justify-end">
            <img
              src={selectedTab.image}
              alt={`Preview fitur ${selectedTab.title}`}
              className="h-auto w-full max-w-xs object-contain sm:max-w-sm md:max-w-md lg:max-w-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
}